import { UIdateFormateNotTime } from "../../../helper/func";

export const tableDatas = [
  {
    title: 'Status',
    prop: 'status',
    sorting: false,
    show: true,
    className: '',              // optional class names space delimited list for title item ex: "text-center"  
    wrapper: {
        element: 'span',
        checkConditionForClass: (prop) => {
          switch(prop) {
            case "Active": 
              return 'badge badge-success';
            case "Inactive":
                return 'badge badge-secondary'
            default: return 'badge badge-info';
          };
        },
      },
  },
  {
    title: 'Role Name',
    prop: 'roleName',
    sorting: false,
    show: true,
    //className: '',              // optional class names space delimited list for title item ex: "text-center"
  },  
  {
    title: 'Updated Date',
    prop: 'updatedDate',
    sorting: false,
    show: true,
    formatFunc: UIdateFormateNotTime,                // change value's format with function
  },
  {
    title: 'Updated By',
    prop: 'updatedBy',
    sorting: false,
    show: true,
  },
  {
    title: 'Action',
    className: 'py-1',
    show: true,
    items: [
      {
        value: 'Edit',
        wrapper: {                            // optional wrapper object
          element: 'button',                  // required valid HTML5 element tag
          clickProps: 'onClickEdit', 
          clickEventParamProp: 'roleKey',
          attributes: {                       // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
            className: 'btn btn-primary btn-sm mt-1 mr-2 mb-sm-0 mb-1',
          },
        },
      },
      {
        value: 'Delete',
        wrapper: {                       
          element: 'button',
          clickProps: 'onClickDelete', 
          clickEventParamProp: 'roleKey',           
          attributes: { 
            className: 'btn btn-danger btn-sm mt-1',
            // "data-toggle": "modal",
            // "data-target": "#deleteModal",
          },
        },
      },
    ],
  },
];